<template>
  <div class="t-lk-modal__content">
    <h2 class="t-lk-modal__title" v-html="$root.staticText.lk.missingDataTitle"></h2>

    <div v-if="props.moderateText" class="t-lk-missing-data__text" v-html="props.moderateText"></div>

    <CoreForm
      v-else
      class="t-lk-missing-data__form"
      action="lk/partner/update"
      :form-config="props.formInfo"
      :submit-label="props.button"
      :agreements="[PERSONAL_DATA_AGREEMENT]"
      @submit:success="onSuccessSubmit"
      @submit:error="onErrorSubmit"
    ></CoreForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CoreForm from '@shared/ui/public/forms/CoreForm.vue'
import { PERSONAL_DATA_AGREEMENT } from '@shared/const/form/form.field'

export default {
  name: 'missing-data',
  props: ['props'],
  components: {
    CoreForm,
  },
  computed: {
    PERSONAL_DATA_AGREEMENT() {
      return PERSONAL_DATA_AGREEMENT
    },
  },
  methods: {
    ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),

    onSuccessSubmit() {
      this.modalClose()

      this.modalType_successOpen({
        title: this.$root.staticText.modal.successTitleFeedback,
        text: this.$root.staticText.modal.successTextFeedback,
        class: '_small',
      })
    },
    onErrorSubmit() {
      this.modalClose()

      this.modalType_errorOpen({
        title: this.$root.staticText.modal.errorTitle,
        text: this.$root.staticText.modal.errorText,
        class: '_small',
      })

      window.location.reload()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/base/modals/missing-data.vue